import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: 48px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`

export const IconWrapper = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background: #FFF3E6;
`

export const TitleNoNotification = styled.div`
  color: #222;
  text-align: center;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const SubtitleNoNotification = styled.div`
  color: #555;
  text-align: center;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
